export const blockIconsMapsExploreNew = (
	<span className='material-symbols-outlined'>explore</span>
);
